import { type FC } from "react";

import { Colors } from "@snapchat/snap-design-system";
import { Sizes } from "@snapchat/snap-design-system-icons";

interface MonetizationIconProps {
    size?: Sizes;
    fill?: string;
}

export const MonetizationIcon: FC<MonetizationIconProps> = ({ size = Sizes.Medium, fill = Colors.Black.V100 }) => {
    const px = Number(size);

    return (
        <svg width={px} height={px} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="6.8" stroke={fill} />
            <path
                d="M10 6.25C10 5.42 9.1 4.75 8 4.75S6 5.42 6 6.25 6.9 8 8 8s2 .67 2 1.75S9.1 11.25 8 11.25 6 10.58 6 9.75M8 3.75v1M8 11.25v1"
                stroke={fill}
                strokeWidth={1.2}
                strokeLinecap="round"
            />
        </svg>
    );
};
